// extracted by mini-css-extract-plugin
export default {"app":"AppTile_app__krkuN","icon":"AppTile_icon__BEZMq","name":"AppTile_name__v1cjp"};